var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Table } from "../../../../../Components/UI";
import { Translate } from "../../../../../../I18N";
import { columns, NoDataCell } from "./TableElements";







const ExtractorsTable = ({ paragraphExtractorData, onSelectionChange }) => /*#__PURE__*/
_jsx(Table, {
  data: paragraphExtractorData,
  columns: columns,
  header: /*#__PURE__*/
  _jsx(Translate, { className: "text-base font-semibold text-left text-gray-900 bg-white" }, void 0, "Extractors"

  ),

  enableSelections: true,
  onChange: ({ selectedRows }) => {
    onSelectionChange(paragraphExtractorData.filter((ex) => ex.rowId in selectedRows));
  },
  noDataMessage: /*#__PURE__*/_jsx(NoDataCell, {}) }
);


export { ExtractorsTable };